import { PaymentRecord } from '../../lib/types/models/payment-record/payment-record'
import { PaymentRecordInput } from '../../lib/types/models/payment-record/payment-record-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updatePaymentRecord(data: UpdateInput<PaymentRecordInput>, enrollmentId: number) {
  const { id, ...rest } = data
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.updatePaymentRecord.url, {
        id: enrollmentId,
        paymentRecordId: id
      })
    )
    .patch<PaymentRecord>(rest)
}
